import { MenuItem } from '@mui/material';
import {
  ContextItemFileType,
  ContextItemType,
  ContextItems,
} from 'src/@types/ai';
import { StyledListItemText } from 'src/components/explorer/shared/ExplorerMenuItem';
import Iconify from 'src/components/iconify';
import { AIContextIcon } from '../AIActionButtons/AIContextIcon';
import { useAIContextActionsUtils } from '../AIActionButtons/useAIContextActionsUtils';

type Props = {
  contextFile: ContextItems;
  handleToggleFile: (
    type: ContextItemType,
    contextFile: ContextItemFileType,
  ) => void;
};

const SelectedContextItem = ({ contextFile, handleToggleFile }: Props) => {
  const { getLabel } = useAIContextActionsUtils();
  const item = contextFile[contextFile.type!] as ContextItemFileType;

  return (
    <MenuItem
      key={contextFile[contextFile.type]?._id}
      onClick={() => handleToggleFile(contextFile.type, item)}
    >
      <StyledListItemText>
        <AIContextIcon item={contextFile} />
        <span>{getLabel(contextFile)}</span>
      </StyledListItemText>
      <Iconify icon="tabler:check" color="success.main" ml={2} flexShrink={0} />
    </MenuItem>
  );
};

type SelectedContextItemProps = {
  contextFiles: ContextItems[];
  handleToggleFile: (
    type: ContextItemType,
    contextFile: ContextItemFileType,
  ) => void;
};

export const AIContextSelectionList = ({
  contextFiles,
  handleToggleFile,
}: SelectedContextItemProps) =>
  contextFiles.map((contextFile) => (
    <SelectedContextItem
      key={contextFile[contextFile.type]!._id}
      contextFile={contextFile}
      handleToggleFile={handleToggleFile}
    />
  ));
